import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-dashboard-item-card',
  templateUrl: './dashboard-item-card.component.html',
  styleUrls: ['./dashboard-item-card.component.scss'],
})
export class DashboardItemCardComponent implements OnInit {
  @Input() counter: string;
  @Input() description: string;
  @Input() detailUrl: string;
  @Input() bodyCssClass: string;
  @Input() footerCssClass: string;
  @Input() icon: string;

  constructor(private router: Router) {}

  ngOnInit(): void {}

  btnClick() {
    this.router.navigateByUrl(this.detailUrl);
  }
}
